import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  name: '',
  status: '',
  search: '',
};
export const courseItemSlice = createSlice({
  name: 'course',
  initialState,
  reducers: {
    setItem: (state, action) => {
      const { name, value } = action.payload;
      state[name] = value;
    },
    setDefaultValue: (_, action) => {
      if (!action?.payload?.id) return initialState;
      return { ...action.payload };
    },
    resetData: () => {
      return initialState;
    },
  },
});
export const { setItem, setDefaultValue, resetData } = courseItemSlice.actions;

export default courseItemSlice.reducer;
